import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { userTheme } from '../config';

const formStyles = makeStyles(theme => ({
  Form: {
    '&__container': {
      minHeight: '100%',
      position: 'relative',
      width: '100%',
      marginTop: 80,
      padding: 20,
    },
    '&__header': {
      fontSize: '1.57em',
      marginBottom: '0.75rem',
      marginTop: '10px',
    },
    '&__label': {
      fontSize: '12px',
      lineHeight: 2.5,
      color: `${theme.palette.green} !important`,
      '&--select': {
        lineHeight: 'initial',
      },
    },
    '&__icon': {
      '&--big': {
        width: 100,
        height: 100,
      },
    },
    '&__card': {
      border: '2px solid',
      borderColor: theme.palette.green,
      borderRadius: 5,
      marginBottom: 5,
      '&--lower-bottom': {
        marginBottom: 15,
      },
      '&--box-shadow': {
        boxShadow: '0 0 12px rgba(6, 182, 212, 0.15)',
        '&:hover': {
          boxShadow: '0 0 12px rgba(6, 182, 212, 0.3)',
        },
      },
    },
    '&__map': {
      height: '500px',
      marginBottom: theme.spacing(9),
      marginTop: theme.spacing(5),
    },
    '&__overflow-component': {
      maxHeight: '65vh',
      minHeight: '30vh',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: 5,
      '&--small': {
        padding: 15,
        maxHeight: '50vh',
      },
      '&--no-min-height': {
        minHeight: 'initial',
      },
      '&--with-map': {
        height: 'calc(75vh - 80px)',
        overflow: 'hidden',
      },
    },
    '&__select': {
      marginLeft: 0,
      paddingLeft: 0,
      minWidth: '150px',
      '&__menu': {
        '&--background-color': {
          backgroundColor: `${theme.palette.white} !important`,
        },
        '&__item': {
          '& li': {
            color: theme.palette.black,
            '&:hover': {
              color: theme.palette.white,
              backgroundColor: `${theme.palette.green} !important `,
            },
          },
        },
      },
      '&:after': {
        borderColor: `${theme.palette.green} !important`,
      },
    },
    '&__switch': {
      color: `${theme.palette.green} !important`,
      '&__stepper': {
        backgroundColor: 'initial',
        flex: 2,
      },
      '&__track': {
        backgroundColor: `${theme.palette.green} !important`,
      },
    },
    '&__text-field': {
      color: `${theme.palette.white} !important`,
      '&__form-helper': {
        padding: '2px',
        '&--error': {
          backgroundColor: theme.palette.error.main,
          borderRadius: 25,
          color: `${theme.palette.white} !important`,
          padding: '1px 15px',
          border: '1px solid',
        },
      },
      '&__title': {
        textAlign: 'center',
        fontWeight: 700,
      },
      '&__subtitle': {
        fontWeight: 700,
      },
      '&--black': {
        color: `${theme.palette.black} !important`,
      },
      '&--focused': {
        color: `${theme.palette.green} !important`,
        '&--width, & fieldset': {
          borderColor: `${theme.palette.green} !important`,
        },
      },
      '&--small-font': {
        fontSize: 12,
      },
    },
    '&__tabs': {
      padding: 'initial',
      '&__button': {
        backgroundColor: `${theme.palette.green} !important`,
        '&--width': {
          width: '50% !important',
        },
      },
      '&--background-color': {
        backgroundColor: theme.palette.blackAlfa,
      },
    },
    '&--bottom-of-container': {
      position: 'absolute',
      bottom: 5,
      width: '100%',
    },
    '&--flex': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      '&--center': {
        justifyContent: 'center',
      },
      '&--between': {
        justifyContent: 'space-between',
      },
      '&--direction': {
        flexDirection: 'column',
      },
      '&--flex-end': {
        justifyContent: 'flex-end',
      },
    },
    '&--height': {
      height: '100%',
      '&--dashboard-min-height': {
        minHeight: 420,
      },
    },
    '&--padding-left-right': {
      padding: '0 15px',
    },
    '&--width': {
      width: '100%',
    },
    '&--invert': {
      filter: theme.palette.invertIcon,
      '&--black': {
        filter: theme.palette.invertBlackIcon,
      },
    },
    '&--text-shadow': {
      cursor: 'pointer',
      transition: 'color 0.2s ease',
      '&:hover': {
        textDecoration: 'none',
        color: theme.palette.green,
      },
    },
  },
  FormCalc: () => {
    if (theme.palette.type === userTheme.dark) {
      return {
        backgroundColor: theme.palette.sideBarBackgroundColor,
        border: '0 none',
        borderRadius: '.2232rem',
        boxShadow: `0 6px 10px -4px ${theme.palette.iconDivider}`,
        color: theme.palette.backgroundColor,
        margin: '0 auto',
        padding: '0px 15px',
        transition: `transform 300ms 
                    cubic-bezier(0.34, 2, 0.6, 1), 
                    box-shadow 200ms ease, 
                    -webkit-transform 300ms 
                    cubic-bezier(0.34, 2, 0.6, 1)`,
        maxWidth: '700px',
      };
    }
    return {
      backgroundColor: theme.palette.white,
      border: '0 none',
      borderRadius: '12px',
      boxShadow: `0 6px 10px -4px ${theme.palette.iconDivider}`,
      margin: '0 auto',
      transition: `transform 300ms 
                  cubic-bezier(0.34, 2, 0.6, 1), 
                  box-shadow 200ms ease, 
                  -webkit-transform 300ms 
                  cubic-bezier(0.34, 2, 0.6, 1)`,
      maxWidth: '700px',
    };
  },
}));

const endAdornmentProps = value => (
  <InputAdornment
    disableTypography
    position="end"
    classes={{ root: `${formStyles().Form}__text-field` }}
  >
    {value}
  </InputAdornment>
);

export { formStyles, endAdornmentProps };
